var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{attrs:{"size":"sm","variant":"outline-secondary"},on:{"click":function($event){$event.preventDefault();return _vm.compare()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }